/**
 * Centralized Application Configuration
 * Single source of truth for backend URL
 */

const IS_DEVELOPMENT = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

/**
 * Backend API Base URL
 * Change this URL in ONE place to update across the entire application
 */
export const BACKEND_URL = IS_DEVELOPMENT
  ? 'http://localhost:3001'
  : 'https://ai-prompt-enhancer-backend.fly.dev';
